import $ from "jquery";
import React from 'react';
import { Button, Dropdown } from 'semantic-ui-react';

import Title from '../../title';
import GetDate from '../../../functions/date';
import Server from '../../../functions/server';


export default class JoCardReport extends React.Component {

  state = {
    fromDate: GetDate(new Date(), 'fromDate'), //Set From Date
    toDate: GetDate(new Date(), 'toDate'), //Set To Date
    jobCards: [], status: 'All', worktype: 'All'
  }

  componentDidMount() {
    this.getJobReport();
  }


  getJobReport = () => {
    let context = this;
    let  { fromDate, toDate, worktype, status } = this.state;
    $.ajax({
      type: 'POST', data: { fromDate, toDate, worktype, status }, url: Server() + 'Sales/JobCard/GetAllJobs.php',
      success: function (data) {
        console.log(data);
          try {
            data = JSON.parse(data);
            context.setState({ jobCards: data })
          } catch (error) {
            alert('Error')
          }
      },
      error: function (e) {
          alert('Try again1!!')
          context.setState({ load: false });
      }
  });
  }

  convertIntoNumber(value) {
    try {
        value = Number(value);
    } catch (error) {
        value = 0;
    }
    return value;
}

makeDecimal(value) {
    try {
        value = value.toFixed(2);
    } catch (error) {
        value = 0;
    }
    return value;
}

selectworktype = (f, { value }) => {
  this.setState({ worktype: value });
}

selectStatus = (f, { value }) => {
  this.setState({ status: value });
}


  render() {
    let  { jobCards, worktype, status,  } = this.state;
    let i = 1;
    let modeOption = [
      { text: 'All', key: 'MiAllnor', value: 'All' },
      { text: 'Minor', key: 'Minor', value: 'Minor' },
      { text: 'Semi Major', key: 'Semi Major', value: 'Semi Major' },
      { text: 'Major', key: 'Major', value: 'Major' },
      { text: 'Free Service', key: 'Free Service', value: 'Free Service' },
      { text: 'Warrenty Service', key: 'Warrenty Service', value: 'Warrenty Service' },
      { text: 'Other', key: 'Other', value: 'Other' }
  ]

  let statusOption = [
    { text: 'All', key: 'MiAllnor', value: 'All' },
    { text: 'Process', key: 'Process', value: 1 },
    { text: 'Completed', key: 'Completed', value: 2 },
  ]
    return (
      <div>
        <Title title={'JobCard Report'} openDrawer={this.props.openDrawer} />
        <div style={{margin: '2px'}}>
          <div style={{display: 'flex', margin: '5px'}}>
              <div>
                  <b>From Date</b><br/>
                  <input type="date" value={this.state.fromDate} style={{width: '100%', height: 35 }}
                      onChange={ (event) => { this.setState({ fromDate: event.target.value }) }} />
              </div>
              <div style={{marginLeft: '2px'}}>
                  <b>To Date</b><br/>
                  <input type="date" value={this.state.toDate} style={{width: '100%', height: 35 }}
                      onChange={ (event) => { this.setState({ toDate: event.target.value }) }} />
              </div>

              <div style={{marginLeft: '2px'}}>
                <b>Status</b><br/>
                <Dropdown fluid search style={{width: '200px'}} onChange={this.selectStatus} selection 
                  options={statusOption} value={status} />
              </div>
              <div style={{marginLeft: '2px'}}>
                <b>Work Type</b><br/>
                <Dropdown fluid search style={{width: '200px'}} onChange={this.selectworktype} selection 
                  options={modeOption} value={worktype} />
              </div>
              
              <div style={{marginLeft: '2px'}}>
                  <br/>
                  <Button onClick={this.getJobReport}>Submit</Button>
              </div>
          </div>
          <table width="100%" id="table">
            <tr>
                <th id='tableheader'><center>Sino</center></th>
                <th id='tableheader'><center>Planned Date</center></th>
                <th id='tableheader'><center>Machine</center></th>
                <th id='tableheader'><center>Issue</center></th>
                <th id='tableheader'><center>Machanic Name</center></th>
                <th id='tableheader'><center>Work Mode</center></th>
                <th id='tableheader'><center>Estimate Time</center></th>
                <th id='tableheader'><center>Rate</center></th>
                <th id='tableheader'><center>Tax</center></th>
                <th id='tableheader'><center>Total</center></th>
                <th id='tableheader'><center>Status</center></th>
            </tr>
            {
              jobCards.map((c) => {
                let price = this.convertIntoNumber(c.price);
                let tprice = this.convertIntoNumber(c.tprice);
                return (
                  <tr>
                    <td>{i++}</td>
                    <td>{c.date}</td>
                    <td>{c.machine}</td>
                    <td>{c.title}</td>
                    <td>{c.worker_name}</td>
                    <td>{c.mode}</td>
                    <td>{c.estimate_time+" Hour(s)"}</td>
                    <td style={{textAlign: 'right'}}>{this.makeDecimal(price)}</td>
                    <td style={{textAlign: 'right'}}>{c.tax}</td>
                    <td style={{textAlign: 'right'}}>{tprice}</td>
                    <td style={{textAlign: 'right'}}>
                        {
                            c.status == 1 || c.status == '1' ? 
                            <div  style={{color: 'blue'}}>Process</div> : 
                            <div style={{color: 'green'}}>Completed</div>
                        }
                    </td>
                  </tr>
                )
              })
            }

          </table>
        </div>
      </div>
    );
  }

}